export default __webpack_public_path__ + "static/media/execute_answer_comp_time.d9e7d1fc.png";